import {
  CompanyCreateForm,
  type CompanyCreateFormValues,
} from '../company-create-form';
import { useUpdateCompany } from '@entities/company';
import { useParams } from 'react-router';
import { QueryKey } from '@shared/config';
import { useQueryClient } from '@tanstack/react-query';
import { showNotification } from '@shared/utils';
import { useFeatureFlag } from '@packages/feature-flags/react';

type CompanyUpdateProps = {
  initialValues: CompanyCreateFormValues;
  initialNccVerified?: boolean | null;
  handleBack: () => void;
};

export const CompanyUpdate = ({
  initialValues,
  initialNccVerified,
  handleBack,
}: CompanyUpdateProps) => {
  const { id } = useParams();
  const queryClient = useQueryClient();
  const manualNccConfirmationEnabled = useFeatureFlag('manualNccConfirmation');

  const { mutate: updateCompany, isPending: isUpdatePending } =
    useUpdateCompany(id || '');

  const handleSubmit = (values: CompanyCreateFormValues) => {
    updateCompany(
      {
        name: values.name,
        type: values.type || null,
        nif: values.nif,
        cityId: values.city ? Number(values.city) : null,
        description: values.description,
        managerId: Number(values.manager),
        economicActivitiesIds: (values.economicActivitiesIds ?? []).map(Number),
      },
      {
        onSuccess: data => {
          queryClient.setQueryData([QueryKey.GET_COMPANY, id], data);

          queryClient.invalidateQueries({
            queryKey: [QueryKey.GET_REGIONS],
          });
          queryClient.invalidateQueries({
            queryKey: [QueryKey.GET_COMPANIES],
          });

          handleBack();
        },
        onError: error => {
          showNotification({
            error,
            variant: 'error',
            message:
              error.response?.data.message || 'Не удалось обновить компанию',
          });
        },
      }
    );
  };

  return (
    <CompanyCreateForm
      withBorder
      successButtonText='Сохранить'
      handleBack={handleBack}
      handleSubmit={handleSubmit}
      initialValues={initialValues}
      initialNccVerified={initialNccVerified}
      companyId={manualNccConfirmationEnabled ? id : undefined}
      isLoading={isUpdatePending}
      isDisabled={isUpdatePending}
      isEdit
    />
  );
};
